/**
 * Ritual value message for the default product template (product.sections.json).
 * Shown only when compare-at price is set and higher than the sale price.
 */
(function () {
  if (window.PXUTheme.buildRitualValueMessage) {
    return;
  }

  window.PXUTheme.buildRitualValueMessage = function (salePrice, compareAtPrice, formatter) {
    if (!compareAtPrice || compareAtPrice <= salePrice) {
      return '';
    }

    const template = window.PXUTheme.translation.ritual_value_message;

    if (!template) {
      return '';
    }

    const salePriceHtml = `<span class="money">${formatter(salePrice)}</span>`;
    const compareAtPriceHtml = `<span class="money">${formatter(compareAtPrice)}</span>`;

    return template
      .replace(/\[\[sale_price\]\]/g, salePriceHtml)
      .replace(/\[\[compare_at_price\]\]/g, compareAtPriceHtml);
  };
})();
